import { render, staticRenderFns } from "./AboutUsCardsSection.vue?vue&type=template&id=e88abc24&"
import script from "./AboutUsCardsSection.vue?vue&type=script&lang=js&"
export * from "./AboutUsCardsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports